package ui.campaign.detailv2.editor.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.BlurredEdgeTreatment.Companion.Unbounded
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.blur
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import compose.assets.Svg
import compose.assets.svg.Alert
import compose.assets.svg.CursorHand
import compose.assets.svg.DeleteEmpty
import ui.campaign.detailv2.editor.CampaignEditorScope
import ui.campaign.detailv2.editor.wrapper.ImplCampaignWrapperEVisual
import ui.widget.LazyImage
import kotlin.math.roundToInt


@Composable
fun CampaignEditorScope.ListingEntryVisualItem(
    item: ImplCampaignWrapperEVisual.AdapterVisual.Item,
    openIssueResolver: () -> Unit,
    openResourcePicker: () -> Unit
) {
    Card(
        modifier = Modifier.width(if (item.data.land) (256F * 1.2F).dp else (256F * 0.8F).dp),
        onClick = {
            if (item.invalidVisualDuration) {
                openIssueResolver()
            } else {
                openResourcePicker()
            }
        }
    ) {
        Column {
            Box(
                Modifier
                    .fillMaxWidth()
                    .height((256F).dp)
            ) {
                item.resource?.also {
                    LazyImage(
                        id = it.resourceId,
                        modifier = Modifier.fillMaxSize()
                            .blur(32.dp, Unbounded),
                        contentScale = ContentScale.FillBounds,
                        alphaBackground = false
                    )
                    LazyImage(
                        id = it.resourceId,
                        modifier = Modifier.fillMaxSize(),
                        contentScale = ContentScale.Fit,
                        alphaBackground = false
                    )
                    ElevatedCard(
                        modifier = Modifier.align(Alignment.TopStart)
                            .padding(8.dp),
                        colors = CardDefaults.elevatedCardColors(
                            containerColor = Color.White,
                            contentColor = Color.Black
                        )
                    ) {
                        Text(
                            text = item.key,
                            fontWeight = FontWeight.ExtraBold,
                            style = MaterialTheme.typography.bodyMedium,
                            modifier = Modifier.padding(4.dp)

                        )
                    }
                    SmallFloatingActionButton(
                        onClick = { item.reset() },
                        containerColor = MaterialTheme.colorScheme.errorContainer,
                        contentColor = MaterialTheme.colorScheme.onErrorContainer,
                        modifier = Modifier.align(Alignment.TopEnd)
                            .padding(4.dp)
                    ) { Icon(Svg.DeleteEmpty, null) }

                    if (item.invalidVisualDuration) {
                        Icon(
                            imageVector = Svg.Alert,
                            contentDescription = null,
                            modifier = Modifier
                                .align(Alignment.Center)
                                .alpha(0.8F)
                                .size(128.dp)
                                .background(MaterialTheme.colorScheme.errorContainer, CircleShape)
                                .padding(24.dp)
                        )
                    }
                } ?: run {
                    Text(
                        text = item.key,
                        style = MaterialTheme.typography.headlineLarge,
                        modifier = Modifier.align { content, parent, _ ->
                            IntOffset(
                                (parent.width / 2) - (content.width / 2),
                                (parent.height.toFloat() * 0.33F).roundToInt() - (content.height / 2),
                            )
                        }
                    )
                    Icon(
                        imageVector = Svg.CursorHand,
                        contentDescription = null,
                        modifier = Modifier
                            .size(48.dp)
                            .align { content, parent, _ ->
                                IntOffset(
                                    (parent.width / 2) - (content.width / 2),
                                    (parent.height.toFloat() * 0.66F).roundToInt() - (content.height / 2),
                                )
                            }
                    )
                }
            }
            item.resource?.also {
                Text(
                    text = it.name,
                    style = MaterialTheme.typography.labelSmall,
                    fontWeight = FontWeight.Bold,
                    maxLines = 3,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier.fillMaxWidth()
                        .background(Color.Black)
                        .padding(4.dp)
                        .padding(horizontal = 4.dp)

                )
            }
        }

    }
}